<template>
  <div>
    <span class="member-classes-period-type">
      {{ CoursePeriodsType.getValue(periods_type) }}
    </span>
  </div>
</template>

<script>
import { CoursePeriodsType } from '@/utils/enums';
export default {
  name: 'CoursePeriodsType',
  props: {
    periods_type: {
      require: true,
    },
  },
  data() {
    return {
      CoursePeriodsType,
    };
  },
};
</script>

<style>
.member-classes-period-type {
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  color: #f4242e;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #f4272f;
  margin-right: 8px;
  white-space: nowrap;
  display: inline-block;
}
</style>
